import React, { useState, useEffect } from 'react';
import './FormPersenBunga.css';
import { getFormData } from './FormPersenBungaLogic02';

const FormPersenBunga02 = ({ groupData }) => {
    const [formData, setFormData] = useState({
        tanggalPengamatan: "",
        bagianUnitKerja: "",
        ppn: "",
        statusLokasi: "",
        namaPengamat: "",
        namaPengamatPertama: "-",
        namaMandor: "-",
        plotData: [],
        signaturePengamat: null,
        signatureMandor: null
    });
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchFormData = async () => {
            if (groupData) {
                setLoading(true);
                try {
                    const data = await getFormData(groupData);
                    setFormData(data);
                } catch (error) {
                    console.error("Error fetching form data:", error);
                    setFormData(prev => ({
                        ...prev,
                        statusLokasi: "Error"
                    }));
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchFormData();
    }, [groupData]);

    // Fungsi untuk menampilkan signature sebagai gambar
    const renderSignature = (signatureBase64, altText) => {
        if (!signatureBase64) {
            return null;
        }

        // Pastikan signatureBase64 adalah string yang valid
        if (typeof signatureBase64 !== 'string') {
            console.error('Signature base64 bukan string:', signatureBase64);
            return null;
        }

        // Tambahkan prefix data URL jika belum ada
        let signatureSrc = signatureBase64;
        if (!signatureBase64.startsWith('data:')) {
            signatureSrc = `data:image/png;base64,${signatureBase64}`;
        }

        return (
            <img 
                src={signatureSrc} 
                alt={altText}
                style={{ 
                    maxWidth: '100%', 
                    maxHeight: '60px',
                    display: 'block',
                    margin: '0 auto'
                }} 
                onError={(e) => {
                    console.error('Error loading signature image:', signatureBase64?.substring(0, 100));
                    e.target.style.display = 'none';
                }}
            />
        );
    };

    if (loading) {
        return (
            <div className="container">
                <div style={{ textAlign: 'center', padding: '20px' }}>
                    Memuat data...
                </div>
            </div>
        );
    }

    return (
        <div className="container">
            {/* Header dengan logo, judul, dan informasi perusahaan */}
            <div className="doc-header">
                {/* Section untuk logo dan perusahaan */}
                <div className="company-section">
                    {/* Area untuk logo SVG */}
                    <div className="logo-container">
                        <img
                            src="/ggp.png"
                            alt="Logo GGF"
                            style={{ width: "60px", height: "auto", borderRadius: "8px" }}
                            className="company-logo"
                            />
                    </div>
                    
                    {/* Informasi perusahaan */}
                    <div className="company-info">
                        <div className="company-name">PT. Great Giant Pineapple</div>
                        <div>Plantation Group Dept 4</div>
                        <div>Pengamatan Pertumbuhan Nanas</div>
                    </div>
                </div>
                
                {/* Judul dokumen */}
                <div className="title-doc">
                    <h1>Pengamatan Populasi, % Bunga & Buah Alami</h1>
                </div>
                
                {/* Informasi dokument */}
                <div className="doc-info">
                    <div className="doc-info-area">
                        <div className="doc-row">
                            <span className="doc-label">No. Doc</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">F/NF/PLT/PPTN/G.03</span>
                        </div>
                        <div className="doc-row">
                            <span className="doc-label">Rev.</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">2</span>
                        </div>
                        <div className="doc-row">
                            <span className="doc-label">Date Issue</span>
                            <span className="doc-label-2"> : </span>
                            <span className="doc-value">10 Oktober 2025</span>
                        </div>
                    </div>
                </div>
            </div>
            
            <div className="doc-body">
                <div className="info-doc">
                    <div className="info-row">
                        {/* Bagian kiri */}
                        <div className="info-left">
                            <div className="info-item">
                                <label>Hari/Tanggal</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="hari-tanggal">
                                    {formData.tanggalPengamatan}
                                </span>
                            </div>
                
                            <div className="info-item">
                                <label>Bagian Unit Kerja</label>
                                <span className="colon">:</span>
                                <span className="input-line short" id="bagian-unit-kerja">
                                    {formData.bagianUnitKerja}
                                </span>
                                <label className="inline">PPN</label>
                                <span className="input-line short" id="ppn">
                                    {formData.ppn}
                                </span>
                            </div>
                
                            <div className="info-item">
                                <label>Status</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="status-lokasi">
                                    {formData.statusLokasi}
                                </span>
                            </div>
                        </div>
                
                        {/* Bagian kanan */}
                        <div className="info-right">
                            <div className="info-item">
                                <label>Halaman</label>
                                <span className="colon">:</span>
                                <span className="input-line short">2</span>
                                <label className="inline">Dari</label>
                                <span className="input-line short">2</span>
                            </div>
                
                            <div className="info-item">
                                <label>Pengamat</label>
                                <span className="colon">:</span>
                                <span className="input-line" id="nama-pengamat">
                                    {formData.namaPengamat}
                                </span>
                            </div>
                        </div>
                    </div>
                </div>
                
                <table className="table-form">
                    <tr className="section-title">
                        <td className="td-form" colSpan="4">Info Lokasi</td>
                        <td className="td-form" colSpan="11">Pinggiran</td>
                    </tr>
                    
                    <tr className="section-title">
                        <td className="td-form" rowSpan="3">Lokasi</td>
                        <td className="td-form" rowSpan="3">Plot</td>
                        <td className="td-form" rowSpan="3">Luas</td>
                        <td className="td-form" rowSpan="3">PJP</td>
                        <td className="td-form" colSpan="4">Berbunga</td>
                        <td className="td-form" rowSpan="3">Buah Alami</td>
                        <td className="td-form" rowSpan="3">Mati</td>
                        <td className="td-form" colSpan="4">Mandul</td>
                        <td className="td-form" rowSpan="3">Total</td>
                    </tr>
                    
                    <tr className="section-title">
                        <td rowSpan="2" className="td-form">Normal</td>
                        <td rowSpan="1" colSpan="2" className="td-form">Penyakit</td>
                        <td rowSpan="2" className="td-form">Kerdil</td>
                        
                        <td rowSpan="2" className="td-form">Normal</td>
                        <td rowSpan="1" colSpan="2" className="td-form">Penyakit</td>
                        <td rowSpan="2" className="td-form">Kerdil</td>
                    </tr>
                    
                    <tr className="section-title">
                        <td rowSpan="1" className="td-form">phy</td>
                        <td rowSpan="1" className="td-form">erw</td>
                        
                        <td rowSpan="1" className="td-form">phy</td>
                        <td rowSpan="1" className="td-form">erw</td>
                    </tr>
                    
                    {/* Data plot rows - menggunakan React rendering */}
                    <tbody id="plot-data-body">
                        {formData.plotData.map((plot, index) => (
                            <tr key={index} className="plot-data-row">
                                <td className="td-form">{plot.lokasi}</td>
                                <td className="td-form">{plot.plot}</td>
                                <td className="td-form">{plot.luas}</td>
                                <td className="td-form">{plot.pjp}</td>
                                <td className="td-form">{plot.normal_bbp_pb}</td> {/* Pinggiran Berbunga Normal */}
                                <td className="td-form">{plot.phy_pbbp_pb}</td>
                                <td className="td-form">{plot.erw_pbbp_pb}</td>
                                <td className="td-form">{plot.kerdil_bbp_pb}</td>
                                <td className="td-form">{plot.buah_alami_p_pb}</td>
                                <td className="td-form">{plot.mati_p_pb}</td>
                                <td className="td-form">{plot.normal_mp_pb}</td>
                                <td className="td-form">{plot.phy_pmp_pb}</td>
                                <td className="td-form">{plot.erw_pmp_pb}</td>
                                <td className="td-form">{plot.kerdil_mp_pb}</td>
                                <td className="td-form">{plot.total_p_pb}</td>
                            </tr>
                        ))}
                    </tbody>
                    
                </table>
            </div>
            
            {/* Area doc-footer untuk tanda tangan */}
            <div className="doc-footer">
                <div className="note-footer">
                    <div className="note-footer-container">
                        <div className="container-section">
                            <h2>Catatan</h2>
                            <p></p>
                        </div>
                    </div>
                </div>
                <div className="validation-footer">
                    <div className="footer-left">
                        <div className="footer-section">
                            <div className="footer-header">Diamati Oleh,</div>
                            <div className="signature-area" id="signature-petugas-ppn">
                                {renderSignature(formData.signaturePengamat, "Signature Pengamat")}
                            </div>
                            <div className="signature-name" id="petugas-ppn">
                                {formData.namaPengamatPertama}
                            </div>
                            <div className="signature-label">Petugas PPN</div>
                        </div>
                        <div className="footer-section">
                            <div className="footer-header">Diperiksa Oleh,</div>
                            <div className="signature-area" id="signature-mandor-ppn">
                                {renderSignature(formData.signatureMandor, "Signature Mandor")}
                            </div>
                            <div className="signature-name" id="mandor-ppn">
                                {formData.namaMandor}
                            </div>
                            <div className="signature-label">Mandor PPN</div>
                        </div>
                    </div>
                    <div className="footer-right">
                        <div className="footer-section">
                            <div className="footer-header">Diterima Oleh,</div>
                            <div className="signature-area" id="signature-sect-head-wilayah"></div>
                            <div className="signature-name" id="sect-head-wilayah">Admad Erdiyanto</div>
                            <div className="signature-label">Sect. Head. PPN</div>
                        </div>
                        <div className="footer-section">
                            <div className="footer-header">Diketahui Oleh,</div>
                            <div className="signature-area" id="signature-sub-dept-head"></div>
                            <div className="signature-name" id="sub-dept-head-wilayah">-</div>
                            <div className="signature-label">Sect. Head. Kebun</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default FormPersenBunga02;